"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatDotIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactUi = require("@100mslive/react-ui");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ChatDotIcon = function ChatDotIcon() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
    css: {
      size: "$6",
      bg: "$brandDefault",
      mx: "$2",
      r: "$round"
    }
  });
};
exports.ChatDotIcon = ChatDotIcon;